export default __webpack_public_path__ + "static/media/no-image-available.12e599dc.png";